module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_9006.aebcb8d1.png";